<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>وضعیت</b-card-title>
      <b-dropdown
        no-caret
        right
        :text="duration"
        variant="transparent"
        class="chart-dropdown"
        toggle-class="p-50"
        size="sm"
      >
        <b-dropdown-item
          v-for="(day,index) in enums('durations')"
          :key="index"
          @click="changeDuration(day)"
        >
          {{ day.text }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-overlay
        :show="loading"
        rounded="sm"
      >
        <b-row>
          <b-col
            v-for="item in statisticsItems"
            xl="6"
            md="auto"
            sm="6"
            :class="item.customClass"
            class="mt-2"
          >
            <b-media
              no-body
            >
              <b-media-aside
                class="mr-1"
              >
                <b-avatar
                  size="40"
                  :variant="item.color"
                >
                  <feather-icon
                    size="20"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title | price }}
                </h4>
                <b-card-text class="font-small-3 mb-0" style="font-size: 12px !important;">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  name: 'EcommerceStatistics',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  data() {
    return {
      loading: false,
      statisticsItems: [
        {
          icon: 'DollarSignIcon',
          color: 'light-primary',
          title: '',
          subtitle: 'رژیم',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'TotalDiet',
        },
        {
          icon: 'BoxIcon',
          color: 'light-danger',
          title: '',
          subtitle: 'رژیم زیره پلاس',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'SicknessDiet',
        },
        {
          icon: 'BoxIcon',
          color: 'light-success',
          title: '',
          subtitle: 'رژیم گیاهی',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'VegetableDiet',
        },
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '',
          subtitle: '1 ماهه بدون محدودیت',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'OneMonthDiet',
        },
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '',
          subtitle: '3 ماهه بدون محدودیت',
          customClass: 'mb-2 mb-sm-0',
          onServer: 'ThreeMonthDiet',
        },
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '',
          subtitle: '6 ماهه بدون محدودیت',
          customClass: '',
          onServer: 'SixMonthDiet',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-primary',
          title: '',
          subtitle: 'ورزش',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'TotalActivityPackage',
        },
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '',
          subtitle: 'TRX',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'TRX',
        },
        {
          icon: 'BoxIcon',
          color: 'light-danger',
          title: '',
          subtitle: 'بدون وسیله',
          customClass: 'mb-2 mb-sm-0',
          onServer: 'WithoutDevice',
        },
        {
          icon: 'BoxIcon',
          color: 'light-success',
          title: '',
          subtitle: 'گرم و سرد کردن',
          customClass: '',
          onServer: 'CoolAndWarm',
        },

        {
          icon: 'UserIcon',
          color: 'light-info',
          title: '',
          subtitle: 'کاربران فعال',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'ActiveUser',
        },
        {
          icon: 'UserIcon',
          color: 'light-info',
          title: '',
          subtitle: 'کاربران جدید',
          customClass: 'mb-2 mb-xl-0',
          onServer: 'NewUser',
        },
      ],
      duration: '1 روز اخیر',
    }
  },
  created() {
    this.setReports(1)
  },
  methods: {
    setReports(val) {
      this.loading = true
      this.$http.post(this.$api.report.zirehReports, {
        Day: val,
      }).then(response => {
        this.statisticsItems.forEach(item => {
          item.title = response.data[item.onServer]
        })
      }).finally(() => this.loading = false)
    },
    changeDuration(e) {
      this.duration = e.text
      this.setReports(e.value)
    },
  },
}
</script>
